import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-220">
      <Header data-id="element-221" />
      <main data-id="element-222">
        <Hero data-id="element-223" />
        <About data-id="element-224" />
        <WhyChooseUs data-id="element-225" />
        <Services data-id="element-226" />
        <FAQ data-id="element-227" />
        <Contact data-id="element-228" />
      </main>
      <Footer data-id="element-229" />
    </div>;
}